<template>
  <div class="email-configuration-form">
    <form action="" @submit.prevent="addEmailRecipient()">
      <h2 class="mb-3">Add Email Recipient</h2>
      <div class="form-group">
        <input
          type="email"
          name="email"
          id="email"
          autocomplete="off"
          required
          class="form-control"
          v-model="email"
          placeholder="email@example.com"
        />
        <label for="email">Email:</label>
      </div>
      <div style="transform: translateY(-20px)">
        <form-field-error-label
          v-for="error in validationErrors.email"
          :key="error"
          :error="error"
        ></form-field-error-label>
      </div>
      <div class="form-group">
        <select
          name="type"
          id="type"
          class="form-control"
          v-model="type"
          required
        >
          <option :value="null" disabled hidden>Select Email Type</option>
          <option
            v-for="option in options"
            v-bind:value="option"
            v-bind:key="option"
          >
            {{ option }}
          </option>
        </select>
        <label for="email">Type:</label>
      </div>
      <div class="d-flex justify-content-end">
        <button class="btn btn-primary">Add</button>
      </div>
    </form>
  </div>
</template>

<script>
import EmailRecipientServiceV2 from '../../../services/V2/EmailRecipientServiceV2';
import FormFieldErrorLabel from '../../AppComponents/Forms/FormFieldErrorLabel.vue';
export default {
  components: {
    FormFieldErrorLabel,
  },
  data() {
    return {
      email: null,
      type: null,
      options: [],
      validationErrors: {
        email: [],
      },
    };
  },
  methods: {
    resetValidationErrors() {
      this.validationErrors.email = [];
    },
    async getEmailRecipientTypes() {
      try {
        const response = await EmailRecipientServiceV2.getEmailRecipientTypes();
        if (response && response.data && response.data.data) {
          this.options = response.data.data;
        }
      } catch (error) {}
    },
    async addEmailRecipient() {
      this.resetValidationErrors();
      try {
        await EmailRecipientServiceV2.addEmailRecipient({
          email: this.email,
          type: this.type.toLowerCase(),
        });

        this.$swal({
          title: 'Success',
          text: 'Email recipient added successfully',
          icon: 'success',
        });

        this.email = null;
        this.type = null;

        this.$emit('on-email-recipient-added');
      } catch (error) {
        if (error && error.response && error.response.status === 422) {
          this.validationErrors.email = error.response.data.errors.email || [];
        } else {
          this.$swal({
            title: 'Error',
            text: 'Failed to add email recipient',
            icon: 'error',
          });
        }
      }
    },
  },
  mounted() {
    this.getEmailRecipientTypes();
  },
};
</script>

<style scoped>
.email-configuration-form {
  background-color: white;
  padding: 12px;
}
</style>
